import styles from './index.module.scss'
import pxToRem from '../../helpers/pxToRem'
import {
    Button,
    ButtonProps,
    IconButton,
    IconButtonProps,
    styled,
} from '@mui/material'

// export const PrimaryButton = styled(Button)(({ theme }) => ({
//     height: 'fit-content',
//     color: styles.shades0,
//     textAlign: 'center',

//     // Text
//     ...theme.typography.ps,

//     minWidth: pxToRem(164),
//     backgroundColor: styles.primaryBlue500,
//     padding: `${pxToRem(8)} ${pxToRem(16)}`,
//     borderRadius: pxToRem(40),
//     typography: theme.typography.ps,
//     '&:hover': {
//         backgroundColor: styles.secondaryBlue300,
//     },
//     '&:disabled': {
//         backgroundColor: styles.neutrals100,
//         color: styles.neutrals500,
//     },
// }))

export const PrimaryButton = (props: ButtonProps) => (
    <Button
        variant="contained"
        color="primaryBlue500"
        {...props}
        sx={{
            ...props.sx,
            minWidth: 164,
            borderRadius: '40px',
        }}
    />
)

export const GreenButton = (props: ButtonProps) => (
    <Button
        variant="contained"
        color="primaryGreen500"
        {...props}
        sx={{
            ...props.sx,
            minWidth: 164,
            borderRadius: '40px',
        }}
    />
)

export const RedButton = (props: ButtonProps) => (
    <Button
        variant="contained"
        color="destructiveRed500"
        {...props}
        sx={{
            ...props.sx,
            minWidth: 164,
            borderRadius: '40px',
        }}
    />
)

// export const GreenButton = styled(Button)({
//     height: 'fit-content',
//     color: styles.shades0,
//     textAlign: 'center',
//     lineHeight: pxToRem(20),
//     minWidth: pxToRem(164),
//     backgroundColor: styles.primaryGreen400,
//     padding: `${pxToRem(8)} ${pxToRem(16)}`,
//     borderRadius: pxToRem(40),
//     '&:hover': {
//         backgroundColor: styles.primaryGreen500,
//     },
//     '&:disabled': {
//         backgroundColor: styles.neutrals100,
//         color: styles.neutrals500,
//     },
// })

export const DestructiveButton = styled(Button)({
    height: 'fit-content',
    color: styles.shades0,
    textAlign: 'center',
    lineHeight: pxToRem(20),
    minWidth: pxToRem(164),
    backgroundColor: styles.destructiveRed500,
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    borderRadius: pxToRem(40),
    '&:hover': {
        backgroundColor: styles.destructiveRed500,
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const SecondaryButton = styled(Button)({
    height: 'fit-content',
    color: styles.primaryBlue500,
    fontSize: pxToRem(14),
    borderRadius: pxToRem(40),
    padding: `${pxToRem(14)} ${pxToRem(16)}`,
    '&:hover': {
        color: styles.primaryBlue600,
    },
})

export const PrimaryOutlinedButton = styled(Button)({
    height: 'fit-content',
    color: styles.primaryBlue500,
    lineHeight: pxToRem(20),
    borderRadius: pxToRem(40),
    border: `1px solid ${styles.primaryBlue500}`,
    minWidth: pxToRem(164),
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    '&:hover': {
        color: styles.secondaryBlue300,
        borderColor: styles.secondaryBlue300,
        background: 'inherit',
    },
    '&:disabled': {
        color: styles.neutrals500,
        borderColor: styles.neutrals300,
    },
})

export const AccountButton = styled(Button)({
    height: 'fit-content',
    color: styles.shades0,
    lineHeight: pxToRem(20),
    borderRadius: pxToRem(40),
    backgroundColor: styles.primaryPurple500,
    minWidth: pxToRem(164),
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    '&:hover': {
        backgroundColor: styles.primaryPurple400,
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const SchoolMainButton = styled(Button)({
    height: 'fit-content',
    color: styles.shades0,
    // lineHeight: '100%',
    borderRadius: pxToRem(40),
    backgroundColor: styles.primaryBlue500,
    minWidth: 'fit-content',
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    '&:hover': {
        backgroundColor: styles.secondaryBlue300,
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const DangerButton = styled(Button)({
    height: 'fit-content',
    color: styles.shades0,
    textAlign: 'center',
    lineHeight: pxToRem(20),
    minWidth: pxToRem(164),
    backgroundColor: '#F5857F',
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    borderRadius: pxToRem(40),
    '&:hover': {
        backgroundColor: '#DB7772',
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const ApproveButton = styled(Button)({
    height: 'fit-content',
    color: styles.shades0,
    textAlign: 'center',
    lineHeight: pxToRem(20),
    minWidth: pxToRem(164),
    backgroundColor: styles.primaryGreen500,
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    borderRadius: pxToRem(40),
    '&:hover': {
        backgroundColor: styles.primaryGreen400,
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const RefereeAgreeButton = styled(Button)({
    height: 'fit-content',
    color: styles.shades0,
    textAlign: 'center',
    lineHeight: pxToRem(24),
    minWidth: pxToRem(164),
    backgroundColor: styles.primaryPurple500,
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    borderRadius: pxToRem(40),
    fontSize: pxToRem(16),

    '&:hover': {
        backgroundColor: styles.primaryPurple400,
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const RefereeDisagreeButton = styled(Button)({
    height: 'fit-content',
    color: styles.shades0,
    textAlign: 'center',
    lineHeight: pxToRem(24),
    minWidth: pxToRem(164),
    backgroundColor: styles.primaryYellow500,
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    borderRadius: pxToRem(40),
    fontSize: pxToRem(16),

    '&:hover': {
        backgroundColor: styles.primaryYellow400,
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const AccountPageButton = styled(PrimaryButton)({
    backgroundColor: styles.secondaryBlue900,
    width: 'fit-content',

    '&:hover': {
        backgroundColor: styles.secondaryBlue800,
    },
})

export const PrimaryDarkButton = styled(Button)({
    color: styles.shades0,
    textAlign: 'center',
    lineHeight: pxToRem(20),
    backgroundColor: styles.secondaryBlue800,
    padding: `${pxToRem(8)} ${pxToRem(16)}`,
    borderRadius: pxToRem(40),
    '&:hover': {
        backgroundColor: styles.secondaryBlue700,
    },
    '&:disabled': {
        backgroundColor: styles.neutrals100,
        color: styles.neutrals500,
    },
})

export const BackChevron = (args: IconButtonProps) => (
    <IconButton {...args}>
        {/* prettier-ignore */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15 18L9 12L15 6" stroke="#555555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> </svg>
    </IconButton>
)

export const EditIconButton = (props?: IconButtonProps) => (
    <IconButton {...props}>
        {/* prettier-ignore */}
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M22.7275 6.61389L23.3867 5.91956C23.7207 5.568 23.7471 5.0846 23.4131 4.75061L23.1846 4.51331C22.8857 4.21448 22.3848 4.25843 22.0596 4.58362L21.374 5.25159L22.7275 6.61389ZM12.3213 15.9655L14.123 15.2096L22.0859 7.24671L20.7324 5.90198L12.7695 13.8737L11.9785 15.6139C11.8906 15.816 12.1191 16.0446 12.3213 15.9655ZM8.98145 21.8629H19.2207C20.9082 21.8629 21.9014 20.8785 21.9014 18.9977V9.71643L20.1436 11.4655V18.8395C20.1436 19.6832 19.6953 20.1051 19.1064 20.1051H9.0957C8.28711 20.1051 7.84766 19.6832 7.84766 18.8395V9.07483C7.84766 8.23108 8.28711 7.80921 9.0957 7.80921H16.5576L18.3066 6.05139H8.98145C7.08301 6.05139 6.08984 7.03577 6.08984 8.91663V18.9977C6.08984 20.8785 7.08301 21.8629 8.98145 21.8629Z" fill="#555555"/> </svg>
    </IconButton>
)
